exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ValuesForSet-6aacda36{display:flex;flex-flow:column nowrap;padding:20px 20px}.langRow-96f72649{display:flex;align-items:center;border-bottom:2px solid #E0E0E0}.langRow-96f72649:last-child{border-bottom:0px}.langRow-96f72649 .langFlag-e68db1fd{padding:20px}.langRow-96f72649>form{width:auto}.langRow-96f72649 .translationForm-216ba9c2{margin-bottom:0px;padding:0px}.langRow-96f72649 .ctas-26420fd4{flex:0 1 auto;margin:0px 0px 0px auto;display:flex;flex-flow:row nowrap}.langRow-96f72649 .ctas-26420fd4>a{width:auto}\n", ""]);

// Exports
exports.locals = {
	"ValuesForSet": "ValuesForSet-6aacda36",
	"langRow": "langRow-96f72649",
	"langFlag": "langFlag-e68db1fd",
	"translationForm": "translationForm-216ba9c2",
	"ctas": "ctas-26420fd4"
};